import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Loader2, MailCheck, KeyRound } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    setBusy(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4" dir="rtl">
      <Card className="w-full max-w-md p-8" data-testid="forgot-password-card">
        {sent ? (
          <div className="text-center space-y-4" data-testid="forgot-password-sent">
            <MailCheck className="w-12 h-12 mx-auto text-emerald-500" />
            <h1 className="font-heading text-2xl font-extrabold">تحقق من بريدك</h1>
            <p className="text-sm text-muted-foreground leading-relaxed">إذا كان البريد مسجلاً لدينا فستصلك رسالة فيها رابط لإعادة تعيين كلمة المرور خلال دقائق. الرابط صالح لساعة واحدة.</p>
            <Link to="/login" className="text-primary font-semibold text-sm" data-testid="back-to-login-link">العودة لتسجيل الدخول</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-5">
            <div>
              <KeyRound className="w-10 h-10 text-accent mb-3" />
              <h1 className="font-heading text-2xl font-extrabold">نسيت كلمة المرور؟</h1>
              <p className="text-sm text-muted-foreground mt-1">اكتب بريدك وسنرسل لك رابطاً لتعيين كلمة مرور جديدة.</p>
            </div>
            <div>
              <Label className="mb-1.5 block">البريد الإلكتروني</Label>
              <Input type="email" dir="ltr" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="you@example.com" data-testid="forgot-email-input" />
            </div>
            <Button type="submit" disabled={busy} className="w-full rounded-xl h-11 gap-2" data-testid="forgot-submit-btn">
              {busy && <Loader2 className="w-4 h-4 animate-spin" />} إرسال الرابط
            </Button>
            <div className="text-center"><Link to="/login" className="text-sm text-muted-foreground hover:text-primary" data-testid="forgot-back-login">العودة لتسجيل الدخول</Link></div>
          </form>
        )}
      </Card>
    </div>
  );
}
